<template xmlns = "http://www.w3.org/1999/html" >
  <div class='popup' :id="tariff.style" v-if="tariff">
    <div class='popup_block' v-if="">
      <div class="close" @click="closeModal()"></div>
      <div class="title_popup">
        <div class="title_pop">
          {{tariff.translations[0].name}}
        </div>
      </div>
      <p>{{tariff.translations[0].description}}</p>
      <div class="data_dey">{{tariff.translations[0].period_text}}</div>

      <del class="price-prev price" v-if="hasPromoCode" style="text-align: center">{{ this.clearPrice + " " + $store.getters.t('course') }}</del>
      <div class="price" style="text-align: center">{{ priceByLang + " " + $store.getters.t('course') }}</div>
      <div><a href="#" @click.prevent="showInput = !showInput" v-if="!showInput" class="promocode-link">{{$store.getters.t('input_promo_code')}}</a></div>
      <div class="promocode"  v-if="showInput" >
        <label for="promo-code" class="promocode__title">{{$store.getters.t('promo_code')}}</label>
        <input type="text" v-model.trim="promoCode" id="promo-code" class="promocode__input">
      </div>

      <div class="resume_tariff">
        <div :class="tariff.style">
          <template v-if="order">
            <ButtonPay :order="order"
                       :tariff="tariff"
                       :price="price"
                       :promo-code="promoCode"
                       :promo-codes="promoCodes"
                       :payment="paymentType"
                       @paymentTypeHandle="(paymentType) => { this.paymentType = paymentType }"
                       :curr="currency"
                       @currencyHandle="(currency) => { this.currency = currency }"
                       :redirect_url="redirect_url"
                       :key="promoCode" />
          </template>
        </div>
      </div>
      <div v-if="tariff.name === 'basic'">
        <div class="title_popup">
          {{$store.getters.t('shear_text')}}
        </div>
        <div class="pos_relative share-buttons share_basic">
          <ul>
            <li>
              <fb-share v-model="is_success"></fb-share>
            </li>
            <!--<li>-->
            <!--<vk-share v-model="is_success"></vk-share>-->
            <!--</li>-->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ButtonPay from "./buttonPay";
  import fbShare from "../../share/facebook";
  import vkShare from "../../share/vk";
  import cvDownloadMix from "../../../mixins/cvDownload";

  export default {
    components: {
      ButtonPay,
      fbShare,
      vkShare,
    },
    mixins: [
      cvDownloadMix
    ],
    computed: {
      priceByLang() {
        const percent = this.promoCodes.filter(_ => _.code === this.promoCode);
        const discount = percent.length ? percent[0].discount : 0;
        return (this.tariff.price_by_lang - (this.tariff.price_by_lang * discount / 100)).toFixed(2);
      }
    },
    data() {
      return {
        is_success: false,
        tariff: false,
        tariffInfo: false,
        order: false,
        redirect_url: '',
        downloadType: '',
        price: 0,
        promoCode: '',
        promoCodes: [],
        paymentType: 'VISA',
        currency: 'AMD',
        showInput: false,
        hasPromoCode:false,
        clearPrice:0
      };
    },
    mounted() {
      this.tariffInfo = this.$store.getters.tariffs.find(_ => _.name === this.$store.getters.modalBuy);
      this.$http({
        method: "post",
        url: "/api/create-order",
        data: {
          tariff: this.tariffInfo
        },
      }).then(res => {
        if (res.data.success) {
          this.tariffs = res.data.tariffs;
          this.order = res.data.order;
          this.redirect_url = window.location.href + '/' + this.order.key + '/' + this.$store.getters.downloadType;
          this.$store.commit("tariffs", res.data.tariffs);
          this.tariff = this.$store.getters.tariffs.find(_ => _.name === this.$store.getters.modalBuy);
          this.price = this.tariff.price_ru;
          this.promoCodes = res.data.promoCodes;
          this.clearPrice = this.priceByLang;
        }
      });
    },
    methods: {
      closeModal() {
        this.$store.commit('modalBuy', false);
      }
    },
    watch: {
      is_success(new_value) {
        if (new_value) {
          this.activateUserStatusBasic(this.$store.getters.downloadType);
        }
      },
      priceByLang(newPrice,oldPrice){
        console.log ( newPrice,oldPrice );
        if(+oldPrice && newPrice !== this.clearPrice){
            this.hasPromoCode = true;
        }else{
          this.hasPromoCode = false;
        }
      }
    }
  };
</script>

<style lang="scss">
  .share-buttons img {
    width: 60px;
    margin: 5px;
  }

  .share-buttons ul {
    display: flex;
    justify-content: center
  }

  .share_basic #vk_like a {
    padding: 0 !important
  }

  .promocode-link{
    text-align: center;
    display: block;
    font-size: 12px;
    text-decoration: underline;
  }
  .promocode-link:hover{
      text-decoration: none;
  }
  .promocode{
    text-align: center;
    margin-top: 10px;
    &__title{
      margin-right: 5px;
     }
     &__input{
       width: 100px;
       border-radius: 5px;
       border: 1px solid #fbcb02;
       height: 30px;
     }
  }
  .price-prev{
    text-align: center;
    display: block;
    color: #fbcb02;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/modals/buyTariff/modalBuy.vue